<template>
  <div id="feedback-bar" v-click-outside="closeWidget" v-if="enable">
    <b-btn @click="handleWidget" variant="primary" pill class="feedback-btn" size="sm">
      <i class="mdi mdi-comment-quote"></i>
      {{ $t('components.feedback.feedback') }}
    </b-btn>
    <transition
        name="custom-classes-transition"
        enter-active-class="animated bounceInRight"
        leave-active-class="animated zoomOut"
    >
      <b-card no-body
              class="feedback-card py-4 d-flex align-items-stretch"
              v-if="showFeedbackWidget">
        <div>
          <b-btn class="close-btn" @click="closeWidget()">
            <i class="mdi mdi-close font-size-20"></i>
          </b-btn>
          <b-btn class="back-btn" @click="tab = 'types'" v-if="tab !== 'types'">
            <i class="mdi mdi-keyboard-backspace font-size-24"></i>
          </b-btn>
          <div>
            <div class="text-center">
              <h1 class="feedback-card-title">
                <img v-if="['issue', 'idea'].includes(tab)" :src="options[tab].icon" width="16"
                     style="margin-bottom: 5px">
                {{ $t('components.feedback.your_mind') }}
              </h1>
            </div>

            <b-card-body class="d-flex" v-if="tab === 'types'">
              <b-btn variant="light" class="btn-card d-flex py-4" @click="setActiveTab('issue')">
                <img src="@/assets/images/feedback/warning.png" width="48">
                <span class="subtitle">{{ $t('components.feedback.issue') }}</span>
              </b-btn>
              <b-btn variant="light" class="btn-card d-flex py-4" @click="setActiveTab('idea')"
                     style="margin-left: 0.5rem">
                <img src="@/assets/images/feedback/idea.png" width="48">
                <span class="subtitle">{{ $t('components.feedback.idea') }}</span>
              </b-btn>
              <b-btn variant="light" class="btn-card d-flex py-4" @click="setActiveTab('other')"
                     style="margin-left: 0.5rem">
                <img src="@/assets/images/feedback/other.png" width="48">
                <span class="subtitle">{{ $t('components.feedback.other') }}</span></b-btn>
            </b-card-body>

            <b-card-body class="justify-content-between" v-if="tab !== 'types' && tab !== 'confirmation'">
              <b-form-group>
                <b-form-textarea
                    name="text"
                    id="text"
                    v-model="text"
                    :placeholder="options[tab].placeholder"
                    class="feedback-text"/>
              </b-form-group>

              <b-form-group class="mt-3">
                <div class="form-buttons">
                  <div class="form-screenshot-btn-ly" v-if="tab !== 'idea'">
                    <div v-if="!capturedImage">
                      <b-tooltip id="capture-tooltip" target="capture-btn" triggers="hover" v-if="!captureLoading">
                        {{ $t('components.feedback.capture') }}
                      </b-tooltip>

                      <b-avatar
                          @click="captureScreenshot"
                          variant="light"
                          class="screenshot-btn"
                          id="capture-btn"
                          button
                          :disabled="captureLoading"
                          rounded>
                        <i class="mdi mdi-camera-outline font-size-18 text-muted" v-if="!captureLoading"></i>
                        <b-spinner v-else small></b-spinner>
                      </b-avatar>
                    </div>

                    <b-avatar
                        v-else
                        variant="light"
                        badge
                        button
                        badge-top
                        @click="showCapturedImg"
                        badge-variant="danger"
                        class="screenshot-btn capture-preview"
                        :src="capturedImage"
                        rounded>
                      <template #badge>
                        <i class="mdi mdi-close img-delete-btn" @click="removeImage"
                           :class="{'disabled': loading}"></i>
                      </template>
                    </b-avatar>
                  </div>

                  <b-btn variant="primary"
                         :disabled="loading || captureLoading || !text"
                         type="submit"
                         @click="summitFeedback"
                         class="form-submit-btn">
                    <b-spinner v-if="loading" small class="mx-1"></b-spinner>
                    <div class="form-submit-btn-text">
                      {{ $t('components.feedback.send_feedback') }}
                    </div>
                  </b-btn>

                </div>
              </b-form-group>
            </b-card-body>

            <b-card-body class="d-flex" v-if="tab === 'confirmation'">
              <div class="confirmation">
                <i v-animate-css="'tada'" class="mdi mdi-check-circle confirmation-icon"></i>
                <div
                    v-animate-css="'fadeInUp'"
                    class="confirmation-text">
                  {{ $t('components.feedback.confirmation_message') }}
                </div>
                <b-btn
                    v-animate-css="'fadeInUp'"
                    variant="light"
                    @click="tab = 'types'"
                    class="confirmation-btn">
                  {{ $t('components.feedback.more_feedback') }}
                </b-btn>
              </div>
            </b-card-body>

          </div>
        </div>
      </b-card>
    </transition>

  </div>
</template>

<script>
import CustomerFeedbackService from "../../Services/Api/CustomerFeedbackService";
import vClickOutside from 'v-click-outside'
import * as pico from '@gripeless/pico'
export default {
  name: "FeedbackWidget",
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      tab: 'types',
      capturedImage: null,
      captureLoading: false,
      loading: false,
      text: '',
      showFeedbackWidget: false,
      enable: false,
      options: {
        issue: {
          placeholder: this.$t('components.feedback.issue_placeholder'),
          icon: require('@/assets/images/feedback/warning.png')
        },
        idea: {
          placeholder: this.$t('components.feedback.idea_placeholder'),
          icon: require('@/assets/images/feedback/idea.png'),
        },
        other: {
          placeholder: this.$t('components.feedback.other_placeholder')
        }
      },
      availableRoutes: {
        'feedback': true,
        'customer': true,
        'settings': true,
        'new.template': true,
        'email.design': true,
        'reviews': true,
        'reviews-show': true,
        'order.list': true,
        'order.show': true,
        'campaigns': true,
        'templates': true,
        'campaigns.create': true,
        'campaign.edit': true,
        'dashboard': true
      }
    }
  },
  watch: {
    showFeedbackWidget(newVal) {
      if (!newVal) {
        this.tab = 'types'
        this.text = ''
        this.capturedImage = null
      }
    },
    '$route.name'(newVal) {
      this.checkRoute(newVal)
    }
  },
  methods: {
    checkRoute(route) {
      if (this.availableRoutes.hasOwnProperty(route)) {
        this.enable = true
      } else {
        this.enable = false
      }
    },
    handleWidget() {
      this.showFeedbackWidget = !this.showFeedbackWidget
    },
    closeWidget() {
      this.showFeedbackWidget = false
    },
    setActiveTab(val) {
      this.tab = val
    },
    removeImage() {
      this.capturedImage = null
    },
    async captureScreenshot() {
      this.captureLoading = true
      await this.canvasSave()
    },
    async summitFeedback() {
      this.loading = true
      const payload = {
        feedback: this.text,
        screenshot: this.capturedImage,
        type: this.tab
      }

      CustomerFeedbackService.store({payload}).then(() => {
        this.tab = 'confirmation'
      }).finally(() => {
        this.loading = false
      })
    },
    showCapturedImg() {
      const vm = this
      const w = window.open('about:blank')
      let image = new Image()
      image.src = vm.capturedImage
      setTimeout(function () {
        w.document.write(image.outerHTML);
      }, 0);
      return false
    },
    canvasSave() {
       pico.dataURL(window, {
          ignore: ['#feedback-bar', '#capture-tooltip', '#roadmap'],
        }).then((result) => {
         this.capturedImage = result.value
         this.captureLoading = false
       });
    },
  },
  created() {
    this.checkRoute(this.$route.name)
  }
}
</script>

<style scoped>
</style>